import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { normalizeLocation } from './history';
import { parseRouteToUrl } from './url';

function parseStringifiedState(string) {
  var _context;

  // HACK: redux-persist (or redux?) is weird and stringifies the value
  // of the state twice, so we have to parse it twice here :/
  var parsed = JSON.parse(string);
  return _reduceInstanceProperty(_context = _Object$keys(parsed)).call(_context, function (all, key) {
    all[key] = JSON.parse(parsed[key]);
    return all;
  }, {});
}

function stringifyState(object) {
  var _context2;

  return _JSON$stringify(_reduceInstanceProperty(_context2 = _Object$keys(object)).call(_context2, function (all, key) {
    all[key] = _JSON$stringify(object[key]);
    return all;
  }, {}));
}

export var persistor = {
  getItem: function () {
    var _getItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
      var stored, state, currRoute, latestRoute, isSameRoute;
      return _regeneratorRuntime.wrap(function _callee$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              stored = window.sessionStorage.getItem(key);

              if (stored) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", stored);

            case 3:
              state = parseStringifiedState(stored);
              currRoute = normalizeLocation(window.location);
              latestRoute = state === null || state === void 0 ? void 0 : state.locations[state === null || state === void 0 ? void 0 : state.current];
              isSameRoute = currRoute && latestRoute && parseRouteToUrl(currRoute) === parseRouteToUrl(latestRoute);

              if (isSameRoute) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return", undefined);

            case 9:
              return _context3.abrupt("return", stored);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee);
    }));

    function getItem(_x) {
      return _getItem.apply(this, arguments);
    }

    return getItem;
  }(),
  setItem: function setItem(key, item) {
    return new _Promise(function (resolve) {
      var _context4, _context5;

      // HACK: since we persist the history here, even though it is in session storage,
      // if the user keeps using the same tab and navigating to a lot of pages, this might
      // get quite memory heavy, so we limit "history" and "locations" here to 200 entries
      // which should be more than enough
      var state = parseStringifiedState(item);

      var history = _spliceInstanceProperty(_context4 = _toConsumableArray(state.history)).call(_context4, -200);

      var locations = _reduceInstanceProperty(_context5 = state.history).call(_context5, function (all, key) {
        all[key] = state.locations[key];
        return all;
      }, {});

      resolve(window.sessionStorage.setItem(key, stringifyState(_objectSpread(_objectSpread({}, state), {}, {
        history: history,
        locations: locations
      }))));
    });
  },
  removeItem: function removeItem(key) {
    return new _Promise(function (resolve) {
      resolve(window.sessionStorage.removeItem(key));
    });
  }
};